<mat-toolbar class="sitemenu mat-elevation-z6">
  <mat-toolbar-row>
    <img routerLink="/home" src="../../../assets/images/BANCOM-header-logo.png" width="50px" class="logo-effect" fxShow="true" fxHide.lt-sm="true"/>
    <img routerLink="/home" src="../../../assets/images/BANCOM-header-logo.png" fxHide="true" fxShow.lt-sm="true" width="30px"/>
    <span class="spacer"></span>
    <div class="toggle" fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-xs="column" fxLayoutGap.lt-xs="20px" fxHide.lt-sm="true">
      <button matTooltip="Home" routerLink="/home" mat-button style="margin-right: 21px">
        <span>
          <mat-icon aria-hidden="false" aria-label="Example home icon">home</mat-icon>
        </span>
        <span class="bold content-view bold"></span>
      </button>
      <button matTooltip="Corporate Hiring" routerLink="/corporate-hirings" mat-button style="margin-right: 21px">
        <span>
          <mat-icon aria-hidden="false" aria-label="Example corporate icon">business_center</mat-icon>
        </span>
        <span class="bold content-view bold"></span>
      </button>
      <button matTooltip="For Individual" mat-button [matMenuTriggerFor]="menu" style="margin-right: 21px">
        <span>
          <mat-icon aria-hidden="false" aria-label="Example school icon">school</mat-icon>
        </span>
        <span class="content-view bold"></span>
        <span class="down-icon">
          <i class="fa fa-angle-down"></i>
        </span>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item routerLink="/individual-placements">
          <span class="content-view dropdownbold">Placement</span>
        </button>
        <button mat-menu-item [matMenuTriggerFor]="training" (mouseenter)="trainingMenu" (click)="hideMenu(trainingMenu)" routerLink="/individual-programs/overview" class="content-view dropdownbold">
          Trainings
        </button>
        <mat-menu #training="matMenu"  [hasBackdrop]="false">
          <button mat-menu-item routerLink="/individual-programs/sf-admin-program" class="content-view dropdownbold">
            Salesforce Administration Track
          </button>
          <button mat-menu-item routerLink="/individual-programs/sf-developer-program"
            class="content-view dropdownbold">
            Salesforce Developer Track
          </button>
          <button mat-menu-item routerLink="/individual-programs/vlocity-program" class="content-view dropdownbold">
            Vlocity Developer Track
          </button>
          <button mat-menu-item routerLink="/individual-programs/mulesoft-program" class="content-view dropdownbold">
            Mule Soft
          </button>
          <button mat-menu-item routerLink="/individual-programs/marketing-cloud-program"
            class="content-view dropdownbold">
            Marketing Cloud
          </button>
          <button mat-menu-item routerLink="/individual-programs/service-cloud" class="content-view dropdownbold">
            Service Cloud
          </button>
          <button mat-menu-item routerLink="/individual-programs/sales-cloud" class="content-view dropdownbold">
            Sales Cloud
          </button>
          <button mat-menu-item routerLink="/individual-programs/health-cloud" class="content-view dropdownbold">
            Health Cloud
          </button>
        </mat-menu>
      </mat-menu>
      <span *ngIf="!(isLoggedIn | async)" style="margin-bottom: 14px;">
        <button matTooltip="Login" routerLink="/login" mat-icon-button aria-label="Menu Icon"  mat-button style="margin-right: 21px">
          <mat-icon aria-hidden="false" aria-label="menu icon" style="font-size: 25px;">person</mat-icon>
        </button>
      </span>
      <span *ngIf="isLoggedIn | async" style="margin-bottom: 14px;">
        <button matTooltip="My Account" routerLink="/my-account" mat-icon-button aria-label="Menu Icon"  mat-button style="margin-right: 21px">
          <mat-icon aria-hidden="false" aria-label="menu icon" style="font-size: 25px;">account_circle</mat-icon>
        </button>
        <button matTooltip="Logout" (click)="logout()" mat-icon-button aria-label="Menu Icon"  mat-button style="margin-right: 21px">
          <mat-icon style="font-size: 25px;">power_settings_new</mat-icon>
        </button>
      </span>
     <!--<button routerLink="/login" mat-button style="margin-right: 21px">
        <span>
          <i class="fa fa-sign-in login-icon"></i>
        </span>
        <span class="bold content-view bold">Login</span>
      </button>-->
      <!--<button mat-button [matMenuTriggerFor]="menus">

        <span>
          <mat-icon aria-hidden="false" aria-label="Example people icon">people</mat-icon>
        </span>
        <span class="content-view bold">For Corporates</span> <span class="down-icon">
          <i class="fa fa-angle-down"></i>
        </span>
      </button>
      <mat-menu #menus="matMenu">
        <button mat-menu-item routerLink="/corporate-hirings">
          <span class="content-view dropdownbold ">Hiring</span>
        </button>
        <button mat-menu-item [matMenuTriggerFor]="corporate" routerLink="/corporate-programs/overview"
          class="content-view dropdownbold">
          Trainings
        </button>
        <mat-menu #corporate="matMenu">
          <button class="content-view dropdownbold" mat-menu-item routerLink="/corporate-programs/sf-admin-program">
            Salesforce Administration Track
          </button>
          <button class="content-view dropdownbold" mat-menu-item routerLink="/corporate-programs/sf-developer-program">
            Salesforce Developer Track
          </button>
          <button class="content-view dropdownbold" mat-menu-item routerLink="/corporate-programs/vlocity-program">
            Vlocity Developer Track
          </button>
          <button class="content-view dropdownbold" mat-menu-item routerLink="/corporate-programs/mulesoft-program">
            Mule Soft
          </button>
          <button class="content-view dropdownbold" mat-menu-item routerLink="/corporate-programs/marketing-cloud">
            Marketing Cloud
          </button>
          <button class="content-view dropdownbold" mat-menu-item routerLink="/corporate-programs/sales-cloud">
            Sales Cloud
          </button>
          <button class="content-view dropdownbold" mat-menu-item routerLink="/corporate-programs/service-cloud">
            Service Cloud
          </button>
          <button class="content-view dropdownbold" mat-menu-item routerLink="/corporate-programs/health-cloud">
            Health Cloud
          </button>
        </mat-menu>
      </mat-menu>-->
    </div>
    <span fxHide="true" fxShow.lt-sm="true">
      <button mat-raised-button class="nav_toggle" (click)="openBottomSheet()">
        <i class="fa fa-bars nav_toggle"></i>
      </button>
    </span>
  </mat-toolbar-row>
</mat-toolbar>